export default __webpack_public_path__ + "static/james-brown-ascii-1-9e0dbef87ce83681d72ffec3a3461cdb.png";